<template>
	<div>
		<p class="mgb_10">Restriction Only: group goals, monthly AR history, AR/sales ratios and Excel are unavailable.</p>
		<p class="mgb_10">Sales and collections: {{ period_from }} – {{ period_to }}. Current AR as of {{ as_of }} ({{ time_zone }}).</p>
		<table class="list_tbl mgb_10">
			<thead>
				<tr>
					<th>Sales Group</th>
					<th>Name</th>
					<th>Sales</th>
					<th>Last Year Sales</th>
					<th>Returns</th>
					<th>Last Year Returns</th>
					<th>Net Sales</th>
					<th>Daily Sales</th>
					<th>Current AR</th>
					<th>Period Collections</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in rows" :key="row.sales_group_code">
					<td>{{ row.sales_group_code }}</td>
					<td>{{ row.sales_group_name }}</td>
					<td>{{ row.monthly_sum | toCurrency }}</td>
					<td>{{ row.last_year_monthly_sum | toCurrency }}</td>
					<td>{{ row.return_sum | toCurrency }}</td>
					<td>{{ row.last_year_return_sum | toCurrency }}</td>
					<td>{{ (row.monthly_sum - row.return_sum) | toCurrency }}</td>
					<td>{{ row.daily_sum | toCurrency }}</td>
					<td>{{ row.balance_sum | toCurrency }}</td>
					<td>{{ row.this_month_collection_sum | toCurrency }}</td>
				</tr>
				<tr>
					<td colspan="2">TOTAL</td>
					<td>{{ totals.monthly_sum | toCurrency }}</td>
					<td>{{ totals.last_year_monthly_sum | toCurrency }}</td>
					<td>{{ totals.return_sum | toCurrency }}</td>
					<td>{{ totals.last_year_return_sum | toCurrency }}</td>
					<td>{{ (totals.monthly_sum - totals.return_sum) | toCurrency }}</td>
					<td>{{ totals.daily_sum | toCurrency }}</td>
					<td>{{ totals.balance_sum | toCurrency }}</td>
					<td>{{ totals.this_month_collection_sum | toCurrency }}</td>
				</tr>
			</tbody>
		</table>
		<p v-if="totals.last_year_monthly_sum">Sales / Last Year Sales: {{ ((100 * totals.monthly_sum) / totals.last_year_monthly_sum) | toCurrency }}%</p>
		<p v-if="last_year_net">Net Sales / Last Year Net Sales: {{ ((100 * (totals.monthly_sum - totals.return_sum)) / last_year_net) | toCurrency }}%</p>
		<table class="list_tbl">
			<thead>
				<tr>
					<th>Highest Sales Period</th>
					<th>Date</th>
					<th>Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, index) in highest" :key="index">
					<td>{{ row.period }}</td>
					<td>{{ row.remark }}</td>
					<td>{{ row.invoice_amount | toCurrency }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
const numeric_keys = ['monthly_sum', 'last_year_monthly_sum', 'return_sum', 'last_year_return_sum', 'daily_sum', 'balance_sum', 'this_month_collection_sum'];
export default {
	props: { rows: { type: Array, default: () => [] }, highest: { type: Array, default: () => [] }, as_of: String, time_zone: String, period_from: String, period_to: String },
	computed: {
		totals() {
			return Object.fromEntries(numeric_keys.map(key => [key, this.rows.reduce((sum, row) => sum + Number(row[key] || 0), 0)]));
		},
		last_year_net() {
			return this.totals.last_year_monthly_sum - this.totals.last_year_return_sum;
		},
	},
};
</script>
